export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13317.d0aeb6c0.jpg";